import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle, faToggleOn } from '@fortawesome/pro-solid-svg-icons'

import { Box, Button, Text } from '@domain-group/suit-theme'

const AgencyDisabledBanner = (props) => {
  const { agencyPayload } = props
  const { agency: { active }, callbacks: { manageAgencyEnabledStatus } } = agencyPayload

  if (active) return null

  return (
    <Box alignItems="center" flexDirection={['column', 'row']} marginBottom="large" padding="large" variant="white">
      <Box>
        <Box
          backgroundColor="orange"
          borderRadius={5}
          color="white"
          fontSize="large"
          padding="large"
          width="fit-content"
        >
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Box>

        <Box flexDirection="column" justifyContent="center" marginLeft="large">
          <Text fontSize="small" marginBottom="small">Agency is Disabled</Text>

          <Text fontSize="small" color="bodyFontLightColor" marginTop="small">
            This Agency has been disabled. Please refer to notes prior to re-activating.
          </Text>
        </Box>
      </Box>

      <Button
        buttonStyle="secondaryUtility"
        height="fit-content"
        icon={<FontAwesomeIcon icon={faToggleOn} />}
        marginTop={['large', 0]}
        onClick={() => manageAgencyEnabledStatus()}
        size="medium"
        width={['100%', 'fit-content']}
      >
        Enable Agency
      </Button>
    </Box>
  )
}

AgencyDisabledBanner.propTypes = {
  agencyPayload: PropTypes.shape({
    agency: PropTypes.object.isRequired,
    callbacks: PropTypes.shape({
      manageAgencyEnabledStatus: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
}

export default AgencyDisabledBanner
